"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
const lodash_1 = __importDefault(require("lodash"));
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const GlobalStateProvider_1 = require("../../GlobalStateProvider");
const option_1 = require("../option");
const CheckBox_1 = require("./CheckBox");
const InfinityScroll_1 = __importDefault(require("./InfinityScroll"));
const Paging_1 = __importDefault(require("./Paging"));
const TableHeader_1 = require("./TableHeader");
const TableItem_1 = __importDefault(require("./TableItem"));
// 컴포넌트 선언
exports.Table = react_1.default.memo(({ className, selectedId, forceShowheader = true, titleFontClass = 'body3', showIndex = false, showCheckBox = false, isInfinite, isInnerPage = false, isKeepChecked = false, accumulateAllCheck = false, data = [], showCount = 10, pagingCount = 10, isSMS = false, indexOrder = 'asc', defaultCheckList, disableIdList = [], padding = true, noPaging, page, totalCount, sortDefault, headTitleList, renderTitle, renderFixItem, renderGuidItem, renderItem, renderMoreItem, renderEmpty, option, styles, handlerMoreData, handlerSelectItem, handlerUpdateList, handlerCheckList, setFixedAllChecked, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    // 상태 정의
    const [sort, setSort] = (0, react_1.useState)(sortDefault);
    const [desc, setDesc] = (0, react_1.useState)(false);
    const [allChecked, setAllChecked] = (0, react_1.useState)(false);
    const [checkedList, setCheckedList] = (0, react_1.useState)([]);
    const [tableList, setTableList] = (0, react_1.useState)(data);
    const isShowMore = (0, react_1.useMemo)(() => tableList?.length < totalCount, [tableList, totalCount]);
    const tableOption = (0, react_1.useMemo)(() => lodash_1.default.merge({}, option_1.TableOption, option), [option]);
    const handlerScroll = (0, throttle_1.default)(() => {
        APP.eventManager.publish('scroll');
    }, 1000, { leading: true, trailing: false });
    // 정렬 업데이트 핸들러
    const handlerUpdateSort = (changeSort) => {
        if (sort === changeSort) {
            setDesc(!desc);
        }
        else {
            setSort(changeSort);
            setDesc(false);
        }
    };
    const handlerUpdateCheck = () => {
        setCheckedList([]);
    };
    const cleanCheckList = props => {
        if (props?.className === 'sms-send-list') {
            setCheckedList(props?.defaultChekList ? props.defaultChekList : []);
            return;
        }
        if (props?.className !== className)
            return;
        setCheckedList([]);
    };
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('SUCCESS_DELETE', handlerUpdateCheck);
        return () => {
            APP.eventManager.unsubscribe('SUCCESS_DELETE', handlerUpdateCheck);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('UPDATE_TABLE_ITEM', cleanCheckList);
        return () => {
            APP.eventManager.unsubscribe('UPDATE_TABLE_ITEM', cleanCheckList);
        };
    }, [className]);
    (0, react_1.useEffect)(() => {
        if (!isInfinite && !isKeepChecked) {
            setCheckedList([]);
        }
    }, [page]);
    (0, react_1.useEffect)(() => {
        if (handlerCheckList) {
            handlerCheckList(checkedList);
        }
    }, [checkedList]);
    (0, react_1.useEffect)(() => {
        throttleAllChecked();
    }, [tableList, checkedList, disableIdList]);
    (0, react_1.useEffect)(() => {
        if (defaultCheckList && defaultCheckList.length > 0 && (!isKeepChecked || isSMS)) {
            setCheckedList(defaultCheckList);
        }
    }, [defaultCheckList, isKeepChecked, isSMS]);
    // 데이터 변경 감지 및 리스트 업데이트
    (0, react_1.useEffect)(() => {
        if (lodash_1.default.isEqual(tableList, data))
            return;
        setTableList(data);
    }, [data]);
    // 정렬 변경 감지 및 리스트 업데이트
    (0, react_1.useEffect)(() => {
        handlerUpdateList && handlerUpdateList(sort, desc);
    }, [sort, desc]);
    const throttleAllChecked = () => {
        const ids = tableList.map(obj => obj.id);
        const newCheckedList = checkedList.filter(item => ids.includes(item));
        const disabledCount = tableList.filter(item => disableIdList.includes(String(item.id))).length;
        const totalCount = tableList.length;
        const validCheckedCount = newCheckedList.length + disabledCount;
        if (totalCount > 0 &&
            ((lodash_1.default.isEqual(ids, checkedList) && checkedList.length === totalCount) ||
                (isKeepChecked && checkedList.length > 0 && validCheckedCount === totalCount))) {
            setAllChecked(true);
        }
        else {
            setAllChecked(false);
        }
    };
    // 체크박스 핸들러
    const handlerCheck = (id, checked) => {
        if (id === 'all') {
            setAllChecked(checked);
            setFixedAllChecked && setFixedAllChecked(checked);
            // 누적 모드: isKeepChecked(비 SMS) 또는 accumulateAllCheck 옵션 — 다른 페이지 선택을 보존한다
            const accumulate = (isKeepChecked && !isSMS) || accumulateAllCheck;
            if (checked) {
                setCheckedList(prevData => {
                    const newIds = tableList.map(item => item.id);
                    return accumulate ? Array.from(new Set([...prevData, ...newIds])) : newIds;
                });
            }
            else {
                setCheckedList(prevData => {
                    const ids = new Set(tableList.map(obj => obj.id));
                    return accumulate
                        ? prevData.filter(item => !ids.has(item)) // ids에 포함되지 않은 항목만 필터링합니다.
                        : [];
                });
            }
        }
        else {
            setCheckedList(checked ? [...checkedList, id] : checkedList.filter(item => item !== id));
        }
    };
    //드래그 앤 드롭 파일 막기
    const handleDrop = e => {
        e.preventDefault();
        const dt = e.dataTransfer;
        // 드롭된 항목이 폴더인지 파일인지 확인
        for (let i = 0; i < dt.items.length; i++) {
            const item = dt.items[i];
            if (item.kind === 'file') {
                const file = item.getAsFile();
                // 파일 확장자 확인 (예시: mp4, mov 확장자만 허용)
                if (file.type.startsWith('video/') &&
                    (file.type.includes('mp4') || file.type.includes('quicktime'))) {
                    // 파일 처리 로직 추가
                }
                else {
                    alert('폴더를 등록할 수 없습니다.');
                    return;
                }
            }
            else {
                alert('폴더를 등록할 수 없습니다.');
                return;
            }
        }
    };
    const handleDragOver = e => {
        e.preventDefault();
    };
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const isAdminPage = window.location.pathname.includes('admin-page');
    const renderPage = (0, react_1.useMemo)(() => {
        if (noPaging)
            return null;
        return (data?.length > 0 &&
            !isInfinite && (react_1.default.createElement(Paging_1.default, { defaultShowCount: pagingCount, showCount: showCount, page: page, pagingCount: pagingCount, data: data, totalCount: totalCount, handlerMoreData: handlerMoreData })));
    }, [noPaging, data, showCount, page, pagingCount, totalCount, isInfinite]);
    const renderTableItem = (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null,
        renderFixItem,
        renderEmpty || (react_1.default.createElement(TableItem_1.default, { isMobile: isMobile, tableList: tableList, page: page, totalCount: totalCount, selectedId: selectedId, showCount: showCount, indexOrder: indexOrder, showCheckBox: showCheckBox, showIndex: showIndex, styles: styles, checkedList: checkedList, disableIdList: disableIdList, handlerSelectItem: handlerSelectItem, handlerCheck: handlerCheck, isInfinite: isInfinite, renderItem: renderItem, renderMoreItem: renderMoreItem })),
        isShowMore && isInfinite && (react_1.default.createElement(InfinityScroll_1.default, { page: page, data: tableList, totalCount: totalCount, handlerMoreData: handlerMoreData })))), [
        tableList,
        totalCount,
        disableIdList,
        page,
        selectedId,
        showCount,
        showCheckBox,
        showIndex,
        indexOrder,
        styles,
        checkedList,
        isInfinite,
        isShowMore,
        handlerMoreData,
    ]);
    // 테이블 컴포넌트 반환
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "table-wrapper", style: { padding: padding && !isMobile && !isAdminPage ? '20px' : '0' } },
            renderTitle,
            react_1.default.createElement("div", { className: `table ${className}` },
                headTitleList?.length > 0 && forceShowheader && (react_1.default.createElement(TableHeader_1.TableHeader, { allChecked: allChecked, titleFontClass: titleFontClass, styles: styles, showCheckBox: showCheckBox, showIndex: showIndex, headTitleList: headTitleList, sort: sort, desc: desc, handlerUpdateSort: handlerUpdateSort, handlerCheck: handlerCheck, tableOption: tableOption })),
                isMobile && renderGuidItem && (react_1.default.createElement("div", { className: "check-btn" },
                    react_1.default.createElement(CheckBox_1.CheckBoxElement, { className: "frame-987158", title: t('assignment.allSelect'), id: "all", iconSize: 22, checked: allChecked, handlerCheck: handlerCheck }),
                    renderGuidItem)),
                react_1.default.createElement("div", { onDrop: handleDrop, onDragOver: handleDragOver, className: "scroll-content", style: styles?.scrollContent, onScroll: handlerScroll },
                    isMobile ? (react_1.default.createElement("div", { className: "table-item-wrap" }, renderTableItem)) : (renderTableItem),
                    isInnerPage && renderPage))),
        !isInnerPage && renderPage));
});
